{
"authority": "https://si-agroid-identityserver.segestest.dk",
"clientId": "urn:xreg-uat",
"redirectUri": "https://uat-xreg.segestest.dk",
"scopes": ["uat.xreg_api.client"],
"protectedResources": [
{
"resourceUri": "https://uat-xreg-api.segestest.dk",
"scopes": ["uat.xreg_api.client"]
}
]
}
